import { defineMessages } from 'react-intl'

const scope = `procurify.vendor.presenter.TaxDataFieldPresenter`

export default defineMessages({
  fieldLabel: {
    id: `${scope}.fieldLabel`,
    defaultMessage: 'Default tax rate',
  },
  noDefaultTaxSet: {
    id: `${scope}.noDefaultTaxSet`,
    defaultMessage: 'No default tax set',
  },
})
